import Rollbar from "rollbar";

export function iniTrackingRollbar(): Rollbar {
  const rollbarConfig: Rollbar.Configuration = {
    accessToken: "104cc4b99b964ceaa7939859e9edfa29",
    captureUncaught: false,
    captureUnhandledRejections: false,
    payload: {
      environment: RUN_ENV,
      client: {
        javascript: {
          source_map_enabled: true, // true by default

          // -- Add this into your configuration ---
          code_version: BUILD_ID,
          // ---------------------------------------

          // Optionally have Rollbar guess which frames the error was
          // thrown from when the browser does not provide line
          // and column numbers.
          guess_uncaught_frames: true
        }
      }
    }
  };

  return new Rollbar(rollbarConfig);
}

export function rollbarError(errorName: string, exceptionObject: Error): void {
  if (exceptionObject != undefined) {
    console.error(exceptionObject.toString());
  } else {
    console.error(
      "Could not print rollbarError because exceptionObject is undefined"
    );
  }

  try {
    if (typeof window.trackingRollbar !== "undefined")
      window.trackingRollbar.error("[GTM] " + errorName, exceptionObject);
  } catch {
    console.error("[GTM] " + errorName, exceptionObject);
  }
}
